export default __webpack_public_path__ + "static/media/14.547d27ad.png";